import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import EventEmitter, { Events } from "./eventemitter";

import {
    users,
    GetWebsites,
    LanguageDetail,
    CompanyInfo,
    CompanyTypeId,
    DepartmentEmails,
    SubjectName,
    DepartmentName,
    Websites,
    DepartmentEmailForms,
    resourcesWebsites,
    Resources,
    resourcesDomain,
    EnableAgentsMDL,
    companyRoleMDL,
    employeeCompanyMDL,
    LanguageMDL,
    RoleInterface,
    WebsiteStatus,
    UserTrainingInfo,
    AllResourcesData,
    ChatTranscriptData,
    EmployeCompanyWebMDL,
    AgentsMDL,
    WebsitePushPages,
    WebsiteCannedMessages,
    VisitorInformationModel,
    VisitorIpInformation,
    VisitorChatHistory,
    LoginResponseModel,
    ApiResult,
    AvailableUserForTransfer,
    OperatorBreakModel,
    AvailableUserForAutoTransfer,
    PersonalCannedMessages,
    OperatorChat,
    UserInfo,
    QAChat,
    PersonalCannedMessages1,
    PushContentMDL,
    UnSentChatMDL,
    CannedMessageWithExpiry,
    AllBlockedIps,
    WebsiteBlockKeywords,
    SmtpModel,
    SmtpInfo_SelectAllModel,
    getUsersByCompanyModel,
    UsersmtpaddressModel,
    AppLookUpByCategoryModel,
    SurveyQuestionsForUserModel,
    LoginResponse,
    wgLogType,
    wgModules
} from "../models/index";

import { CacheKey, cacheService } from "./cacheService";
import { userService } from "./userService";
import { Result } from "../models/Result";
import { OperatorTimeStampModel } from "./wglcsApiService/models/OperatorTimeStampModel";
import { utils } from "../utils";
import { DetectEnvironment } from "../EnvironmentSettings";
import moment from "moment";
import { logger } from "./Logger";
import { LocalStorageService } from "./localStorageService";
import { wgLogs } from "../constants/wgLogs";

class WglcsApiService {
    instance: AxiosInstance;
    signUpInstance: AxiosInstance;
    LoginInstance: AxiosInstance;
    isreLogged = false;

    private baseUrl: string = DetectEnvironment.config.REACT_APP_API_BASE_URL!;
    private translationApiKey: string = process.env.REACT_APP_GOOGLE_TRANSLATION_API_KEY!;
    private baseApiUrl: string = `${this.baseUrl}/ChatAppApi/api`;
    private netStatus: boolean = true;

    constructor() {

        this.LoginInstance = axios.create({
            baseURL: this.baseApiUrl,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                accept: "application/json",
            },
            timeout: 420000, // 7 minuts
        } as AxiosRequestConfig);

        this.instance = axios.create({
            baseURL: this.baseApiUrl,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                accept: "application/json",
            },
            timeout: 420000, // 7 minuts
        } as AxiosRequestConfig);

        this.signUpInstance = axios.create({
            baseURL: 'https://dev1.thelivechatsoftware.com/ChatAppApi/api/',
            // baseURL: 'http://122.129.80.90:8085/api/',
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                accept: "application/json",
            },
            timeout: 200000,
        } as AxiosRequestConfig);

        var userData = userService.GetUserData();
        if (userData != null) {
            this.setAuth(userData.accessToken?.auth_token);
        }
        this.internetConnectivity();

        // Request interceptor
        this.instance.interceptors.request.use(
            (config) => {
                // const log = `Api logs : [${moment().format("h:mm:ss DD/MM/YYYY")}] ----API Request: ${config?.method?.toUpperCase()} ${config.url}`;
                // logger.saveLog(log);
                return config;
            },
            async (error) => {
                // const log = `Api logs : [${moment().format("h:mm:ss DD/MM/YYYY")}] ----API Request Error: ${error}`;
                // logger.saveLog(log);

                const thirdPartAPIResponse = await this.getIpAddress()
                const checkForServerDownAPIResponse = await this.checkForServerDownAPI()
                const log = `API Request Error: ${error} \n Third Party API Response: ${thirdPartAPIResponse}\nCWG API Status: ${checkForServerDownAPIResponse}`;
                logger.log(log);

                return Promise.reject(error);
            }
        );

        this.instance.interceptors.response.use(
            (response) => {
                // const log = `Api logs : [${moment().format("h:mm:ss DD/MM/YYYY")}] ----API Response: ${response.status} ${response.config.url}`;
                // logger.saveLog(log);
                return response;
            },
            async (error) => {
                const responseString = JSON.stringify(
                    error?.response,
                    (key, value) => {
                        return value?.data;
                    },
                );
                const thirdPartAPIResponse = await this.getIpAddress()
                const checkForServerDownAPIResponse = await this.checkForServerDownAPI()
                const log = `API Response Error: ${error?.response?.status || "unknown"} ${error.config?.url || error?.toString()}\nDetails: ${error?.toString()} \nThird Party API Response: ${thirdPartAPIResponse} \nCWG API Status: ${checkForServerDownAPIResponse}`;
                logger.log(log);

                if (error?.response?.status === 401) {
                    const latestIp = await this.getIpAddress()
                    const ip = LocalStorageService.getLocalStorage("loginTimeApi");
                    if (ip != null && ip != undefined && ip != "") {
                        if (latestIp != ip && !this.isreLogged) {
                            this.isreLogged = true
                            // EventEmitter.emit(Events.reLogin, "");

                            var userData = userService.GetUserData();
                            const values = `newIp:${latestIp}, previousIp:${ip},reason:Ip changed`
                            wgLogs.rolePermissionLogs(wgLogType.Insert, wgModules.reLogin, userData?.userLoginData?.userId?.toString()!, values)

                            setTimeout(() => {
                                this.isreLogged = false
                            }, 20000);
                            // EventEmitter.emit(
                            //     Events.sessionExpired,
                            //     "Session expired as you changed your network. Please click on ok and login again"
                            // );
                        }
                    }
                }
                return Promise.reject(error);

                if (axios.isAxiosError(error)) {
                    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
                        const log = `Api logs : [${moment().format("h:mm:ss DD/MM/YYYY")}] ----API Timeout Error: ${error?.message} --- ${error.config?.url}`;
                        logger.saveLog(log);
                    } else {
                        // Handle other Axios errors
                    }
                } else {
                    // Handle non-Axios errors
                }
            }
        );
    }

    internetConnectivity = () => {
        this.instance.interceptors.request.use(
            (config: any) => {
                window.addEventListener("online", this.handleNetworkStatusChange);
                window.addEventListener("offline", this.handleNetworkStatusChange);
                return this.netStatus ? config : "";
                // return config;
            },
            (error) => {
                if (axios.isAxiosError(error)) {
                    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
                        // Handle timeout error
                        // console.log('The request response ECONNABORTED/timed out:', error);
                    } else {
                        // Handle other Axios errors
                        // console.log('Axios response error:', error);
                    }
                } else {
                    // Handle non-Axios errors
                    // console.log('Non-Axios response error:', error);
                }
                // return Promise.reject(error);
            }
        );
    };

    handleNetworkStatusChange = () => {
        if (navigator.onLine) {
            this.netStatus = true;
            window.localStorage.setItem("internetConnectivity", "true");
            // window.location.reload();
        } else {
            this.netStatus = false;
            window.localStorage.setItem("internetConnectivity", "false");
        }
        EventEmitter.emit(Events.internetConnectivityNotify);
    };

    setAuth = (userAuth) => {
        this.instance.defaults.headers.common["Authorization"] = "Bearer " + userAuth;
        this.instance.defaults.headers.common["check-ip"] = "Xq3T3PpUzvYjZryh";
    };

    //signup apis
    signUp = (user) => this.signUpInstance.post<any>("wglcs/packagepresignup", user);
    VerifysignUp = (param) => this.signUpInstance.post<any>("/wglcs/verifysignup", param);
    signuppasswordupdate = (param) => this.signUpInstance.post<any>("/wglcs/signuppasswordupdate", param);
    processpackagesignup = (param) => this.signUpInstance.post<any>("/wglcs/processpackagesignup", param);
    getallcountries = () => this.signUpInstance.get<any>("/wglcs/getallcountries");
    getavailableaddons = () => this.signUpInstance.get<any>("/wglcs/getavailableaddons");
    getstatesbycountryid = (countryId) => this.signUpInstance.get<any>(`/wglcs/getstatesbycountryid?id=${countryId}`);
    getcitiesbystateid = (stateid) => this.signUpInstance.get<any>(`/wglcs/getcitiesbystateid?id=${stateid}`);

    signIn = (user) => this.LoginInstance.post<LoginResponseModel>("wglcs/userinfo_checkandlogin", user);
    wglogin = (user) => this.LoginInstance.post<LoginResponseModel>("wglcs/wglogin", user);

    logoff = (user) => this.instance.post("auth/logoff", user);
    updateuserlog = (body) => this.instance.post("wglcs/updateuserlog", body);

    getvisitoripinformation = (visitorId): Promise<AxiosResponse<ApiResult<VisitorIpInformation[]>>> =>
        cacheService.getOrCreate(CacheKey.VisitorIpInformation, visitorId, () =>
            this.instance.get("wglcs/getvisitoripinformation?visitorId=" + visitorId)
        );

    getvisitoripinformation_v2 = (visitorId): Promise<AxiosResponse<ApiResult<VisitorIpInformation[]>>> =>
        this.instance.get("wglcs/getvisitoripinformation?visitorId=" + visitorId);

    getvisitorinformationbychatid = (chatid): Promise<AxiosResponse<ApiResult<VisitorInformationModel>>> =>
        this.instance.get("wglcs/getvisitorinformationbychatid?chatId=" + chatid);

    GetChatInformationByChatID = (chatid): Promise<AxiosResponse<ApiResult<VisitorInformationModel>>> =>
        this.instance.get("wglcs/GetChatInformationByChatID?chatId=" + chatid);


    getcannedmessagesbywebsite = (WebSiteId, lenguge): Promise<AxiosResponse<ApiResult<WebsiteCannedMessages[]>>> =>
        this.instance.get("wglcs/getcannedmessagestablebywebsite_new?WebSiteId=" + WebSiteId + "&LanguageID=" + lenguge);

    getpercannedmessagesbyuserid = (userId, languageId, isCacheApply): Promise<AxiosResponse<ApiResult<PersonalCannedMessages[]>>> =>
        cacheService.getOrCreate(
            CacheKey.UserCannedMessages,
            userId,
            () => this.instance.get(`wglcs/getpercannedmessagesbyuserid_new?userId=${userId}&languageId=${languageId}`),
            isCacheApply
        );

    getpercannedmessagesbyuserid_new = (userId, languageId, isCacheApply): Promise<AxiosResponse<ApiResult<PersonalCannedMessages1[]>>> =>
        cacheService.getOrCreate(
            CacheKey.UserCannedMessagesNew,
            userId,
            () => this.instance.get(`wglcs/getpercannedmessagesbyuserid_new?userId=${userId}&languageId=${languageId}`),
            isCacheApply
        );

    getpushpagesbywebsiteid1 = (websiteId, isCacheApply): Promise<AxiosResponse<ApiResult<PushContentMDL[]>>> =>
        cacheService.getOrCreate(
            CacheKey.WebsitePushPages1,
            websiteId,
            () => this.instance.get(`wglcs/getpushpagesbywebsiteid?websiteId=${websiteId}`),
            isCacheApply
        );

    getcannedmessagestablebywebsite_withexpiry = (WebSiteId, languageId): Promise<AxiosResponse<ApiResult<CannedMessageWithExpiry[]>>> =>
        this.instance.get(`wglcs/getcannedmessagestablebywebsite_withexpiry?WebSiteId=${WebSiteId}&languageId=${languageId}`);

    getLoggedInResourcesWebsite = (empCompanyId): Promise<AxiosResponse<ApiResult<resourcesWebsites[]>>> =>
        this.instance.get(`/wglcs/getallloggedinresourceswebsites?empComapnyId=${empCompanyId}`);

    getallloggedinresourcesrealtime = (empCompanyId): Promise<AxiosResponse<ApiResult<resourcesWebsites[]>>> =>
        this.instance.get(`/wglcs/getallloggedinresourcesrealtime?employeeCompanyId=${empCompanyId}`);

    getLoggedInResponses = (empCompanyId): Promise<AxiosResponse<ApiResult<Resources[]>>> =>
        this.instance.get(`wglcs/getallloggedinresources?empComapnyId=${empCompanyId}`);
    getAssignedClientWebsites = (userId, empCompanyId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/getassignedwebsiteschatsnoforclient?userId=${userId}&employeeCompanyId=${empCompanyId}`);
    getAssignedWebsites = (userId): Promise<AxiosResponse<ApiResult<resourcesDomain[]>>> =>
        this.instance.get(`wglcs/getassignedwebsiteschatsno?userId=${userId}`);
    getSubjectName = (departmentId): Promise<AxiosResponse<ApiResult<SubjectName[]>>> =>
        this.instance.get("wglcs/getdepartmentsubjects?departmentId=" + departmentId);
    getDepartmentEmails = (departmentId): Promise<AxiosResponse<ApiResult<DepartmentEmails[]>>> =>
        this.instance.get("wglcs/getdepartmentemails?departmentId=" + departmentId);
    getDepartmentName = (websiteId): Promise<AxiosResponse<ApiResult<DepartmentName[]>>> =>
        this.instance.get("wglcs/getdepartments?websiteId=" + websiteId);
    // getwebsitesbyempCompanyId = (empCompanyId): Promise<AxiosResponse<ApiResult<Websites[]>>> =>
    //     this.instance.get(`wglcs/getwebsitesbyempcompany?empCompanyId=${empCompanyId}`);
    getEmailForms = (empCompanyId): Promise<AxiosResponse<ApiResult<DepartmentEmailForms[]>>> =>
        this.instance.get(`wglcs/departmentemailform_selectbyempcompanyid?empCompanyId=${empCompanyId}`);
    insertDepartmentAndEmails = (data) => this.instance.post("/wglcs/insertdepartmentandemails", data);
    updatedDepartmentAndEmails = (data) => this.instance.post("/wglcs/updatedepartmentandemails", data);
    updatedepartmentsorder = (data) => this.instance.post("/wglcs/updatedepartmentsorder", data);
    deleteDepartmentEmails = (id) => this.instance.post(`/wglcs/deletedepartmentemail?emailId=${id}`);
    deleteDepartmentSubjects = (id) => this.instance.post(`/wglcs/deletedepartmentsubject?subjectId=${id}`);
    deleteDepartment = (id) => this.instance.post(`/wglcs/deletedepartment?deptId=${id}`);
    setDepartmentStatus = (data) => this.instance.post("/wglcs/setdepartmentstatus", data);
    getempcompanybycompanytypeid = (companyTypeId): Promise<AxiosResponse<ApiResult<CompanyTypeId[]>>> =>
        this.instance.get(`/wglcs/getempcompanybycompanytypeid?companyTypeId=${companyTypeId}`);

    getempcompanybyempcompanyid = (employeeCompanyId): Promise<AxiosResponse<ApiResult<CompanyTypeId[]>>> =>
        this.instance.get(`/wglcs/getempcompanybyempcompanyid?employeeCompanyId=${employeeCompanyId}`);

    GetCompanyInfoCompanyTypeId = (empId): Promise<AxiosResponse<ApiResult<CompanyInfo[]>>> =>
        this.instance.get(`/wglcs/GetCompanyInfoCompanyTypeId?companyTypeId=${empId}`);

    getcompanyinfoempcompanyid = (empId): Promise<AxiosResponse<ApiResult<CompanyInfo[]>>> =>
        this.instance.get(`/wglcs/getcompanyinfoempcompanyid?empCompanyId=${empId}`);

    GetEmpCompanyLanguagesDetail = (): Promise<AxiosResponse<ApiResult<LanguageDetail[]>>> =>
        this.instance.get(`/wglcs/GetEmpCompanyLanguagesDetail`);
    SaveUserWRoleAndInterfaceWebsite_V2 = (data) => this.instance.post("/wglcs/SaveUserWRoleAndInterfaceWebsite_V2", data);
    GetWebsiteByComId = (compId): Promise<AxiosResponse<ApiResult<GetWebsites[]>>> =>
        this.instance.get(`/wglcs/GetWebsiteByComId?companyId=${compId}`);
    getusertraninginfobywebsiteid = (webId): Promise<AxiosResponse<ApiResult<UserTrainingInfo[]>>> =>
        this.instance.get(`/wglcs/getusertraninginfobywebsiteid?websiteId=${webId}`);
    getusersbycompany = (empCompanyId): Promise<AxiosResponse<ApiResult<users[]>>> =>
        this.instance.get(`wglcs/getusersbycompany?empCompanyId=${empCompanyId}`);
    siteAndChatListForOpTreeApi = (userId) => this.instance.get("wglcs/websiteandchatlistforoptree?userId=" + userId);

    // ...........................Inventory....................
    getInventry = (body): Promise<Result<any>> =>
        this.post("wglcs/getinventory", body);

    updateoperatorwindowstate = async (userLog: Number, isActive: boolean, ignoreAuth: boolean): Promise<any> => {
        if (this.instance.defaults.headers.common["Authorization"] === undefined && ignoreAuth) {
            return Promise.resolve();
        }

        var res = await this.post("wglcs/updateoperatorwindowstate", {
            logId: userLog,
            isActiveOperatorWindow: isActive,
        });

        // if (res?.errors != undefined) {
        //     if (utils.tokenExpire(res?.errors[0]?.Code)) {
        //         if (utils.isElectronBuild()) {
        //             var _userData = userService.GetUserData();
        //             var log = `[${moment().format("h:mm:ss DD/MM/YYYY")}] ---- method:updateoperatorwindowstate -----User Name : ${_userData?.userLoginData?.username
        //                 }`;
        //             window.myAPI.LogoutLog(log);
        //         }

        //         EventEmitter.emit(Events.onLogOut);
        //         return;
        //     }
        // }
        return res;
    };

    UpdateQAWindowState = (userLog: Number, isActive: boolean): Promise<any> =>
        this.instance.post("wglcs/updateqawindowstate", { logId: userLog, status: isActive });
    updateqcwindowstate = (userLog: Number, isActive: boolean): Promise<any> =>
        this.instance.post("wglcs/updateqcwindowstate", { logId: userLog, status: isActive });

    updateoperatortimestamp = (data: OperatorTimeStampModel) => {
        return this.instance.post("/wglcs/updateoperatortimestamp", data);
    };

    saveautoticket = (data) => {
        return this.instance.post("/wglcs/saveautoticket", data);
    };

    updatevisitorchatstatus = (status) => this.instance.post("/wglcs/updatevisitorchatstatus", status);
    updateUserPassword = (password) => this.instance.post("/wglcs/updateuserpassword/", password);

    getChatLimitByUser = (obj) => this.instance.post("/wglcs/getchatlimit_byuser", obj);
    savecannedmessages_expirydate_ticketno = (data) => this.instance.post("wglcs/savecannedmessages_expirydate_ticketno", data);
    SaveTicket_QCRatingByOperator_V1 = (data) => this.instance.post("wglcs/SaveTicket_QCRatingByOperator_V1", data);
    savepersonalcannedmessagesnew = (data) => this.instance.post("wglcs/savepersonalcannedmessagesnew", data);

    // save_pendingpcm = (body): Promise<Result<string>> => this.post<string>(`wglcs/save_pendingpcm`, body)
    get_pendingpcm = (body): Promise<Result<string>> => this.post<string>(`wglcs/get_pendingpcm`, body);

    getcountofnotsentchatsofuserschatids = (employeeId, minutes): Promise<AxiosResponse<ApiResult<UnSentChatMDL[]>>> =>
        this.instance.get("wglcs/getcountofnotsentchatsofuserschatids?employeeId=" + employeeId.toString() + "&minutes=" + minutes);
    getoutstandinggreetsbyuser = (userId): Promise<AxiosResponse<ApiResult<Number>>> =>
        this.instance.get("wglcs/getoutstandinggreetsbyuser?userId=" + userId + "&timeDiff=4");

    getchathistorybyvisitorUpdated = (visitorId): Promise<AxiosResponse<ApiResult<VisitorChatHistory[]>>> =>
        cacheService.getOrCreate(CacheKey.VisitorChatHistory, visitorId, () =>
            this.instance.get("wglcs/GetChatHistoryByVisitorUpdated?visitorId=" + visitorId)
        );

    getchathistorybyvisitorid = (visitorId): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get("wglcs/getchathistorybyvisitorid?visitorId=" + visitorId);

    // updateUserChatCount = (obj) => this.instance.post('/wglcs/updateuserchatcount', obj);

    insertbreakinformation = (logId: Number): Promise<AxiosResponse<ApiResult<OperatorBreakModel>>> =>
        this.instance.post("/wglcs/insertbreakinformation", {
            // breakId: 1,
            // breakStartTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
            // breakEndTime: "",
            logId: logId,
            breakTypeId: 1,
            breakRequest: true,
            // breakApproved: true,
            // approvedBy: "",
            // breakApplyTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        });

    getIsLogIDAlive = (logId: Number): Promise<Result<string>> => this.get(`wglcs/getIsLogIDAlive?logId=${logId}`);

    updatechatrunningstatus = (chatId: number) => this.instance.post("wglcs/updatechatrunningstatus", { chatId: chatId, runningStatus: true });
    updatebreakstarttime = (data) => this.instance.post("/wglcs/updatebreakstarttime", data);
    websiteblockkeywords_selectbyuser = (userID): Promise<AxiosResponse<ApiResult<WebsiteBlockKeywords[]>>> =>
        this.instance.get("wglcs/websiteblockkeywords_selectbyuser?userId=" + userID);
    websiteblockkeywords_selectbyuserv2 = (userID): Promise<AxiosResponse<ApiResult<WebsiteBlockKeywords[]>>> =>
        this.instance.get("wglcs/websiteblockkeywords_selectbyuserv2?userId=" + userID);

    updatebreakendtime = (data) => this.instance.post("/wglcs/updatebreakendtime", data);

    getpushpagesbywebsiteid = (websiteId, isCacheApply): Promise<AxiosResponse<ApiResult<WebsitePushPages[]>>> =>
        cacheService.getOrCreate(
            CacheKey.WebsitePushContent,
            websiteId,
            () => this.instance.get(`wglcs/getpushpagesbywebsiteid?websiteId=${websiteId}`),
            isCacheApply
        );

    inserpushpagesall = (data) => this.instance.post("/wglcs/inserpushpagesall", data);

    getallblockedips = (): Promise<AxiosResponse<ApiResult<AllBlockedIps[]>>> => this.instance.get("wglcs/getallblockedips");
    getqckeywords = (): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get("wglcs/getqckeywords")

    saveBlockedIps = (data) => this.instance.post("/wglcs/saveblockedips", data);

    getAvailableOperators = (websiteId, userId): Promise<AxiosResponse<ApiResult<AvailableUserForTransfer[]>>> =>
        this.instance.get("wglcs/GetAvailableUserForTransfer?websiteId=" + websiteId + "&userId=" + userId);
    getAvailableOperatorsforAutoTransfer = (
        websiteId,
        userId,
        employeeCompanyId
    ): Promise<AxiosResponse<ApiResult<AvailableUserForAutoTransfer[]>>> =>
        this.instance.get(
            "wglcs/GetAvailableUserForTransferByEmployeeCompany?websiteId=" +
            websiteId +
            "&userId=" +
            userId +
            "&EmployeeCompanyId=" +
            employeeCompanyId
        );

    transferChatToOtherOperator = (operatorId: number, chatId: number) =>
        this.instance.post("wglcs/updateuseridforchat", {
            userId: operatorId,
            chatId: chatId,
        });

    updateUserChatCount = (userId: number, currentChats: number) =>
        this.instance.post("wglcs/updateuserchatcount", {
            userId: userId,
            currentChats: currentChats,
        });

    updateVisitorInfo = (obj) => this.instance.post("wglcs/updatevisitorinfo", obj);

    // WebSiteAndChatListForOpTreeApi = (userId: Number): Promise<AxiosResponse<ApiResult<OperatorChat[]>>> =>
    //     this.get("wglcs/websiteandchatlistforoptree?userId=" + userId);

    isclaimchat = (chatId: Number): Promise<Result<string>> => this.get("/wglcs/isclaimchat?chatId=" + chatId);



    WebSiteAndChatListForOpTreeApi = (userId: Number): Promise<Result<string>> => this.get("/wglcs/websiteandchatlistforoptree?userId=" + userId);
    save_pendingpcm = (body): Promise<Result<string>> => this.post<string>(`wglcs/save_pendingpcm`, body);

    getChatsForUser = (userId: Number): Promise<AxiosResponse<ApiResult<OperatorChat[]>>> =>
        cacheService.getOrCreate(CacheKey.UserChats, userId.toString(), () => this.instance.get("/wglcs/getchatsforuser?userId=" + userId));

    getUserInfo = (userId: Number): Promise<AxiosResponse<ApiResult<UserInfo>>> =>
        this.instance.get("/emailform/getuserinfo_userid?userId=" + userId);

    getChatsForQaScreen = (userId: Number): Promise<AxiosResponse<ApiResult<QAChat[]>>> =>
        this.instance.get(`/wglcs/getchatsforqascreen?userId=${userId}&ChatId=0&Stre=23423`);

    getChatsForQaScreenV1 = (userId: Number): Promise<AxiosResponse<ApiResult<QAChat[]>>> =>
        this.instance.get(`/wglcs/getchatsforqascreenV1?userId=${userId}&ChatId=0&Stre=23423`);

    resetForgotPassword = (obj) => this.instance.post("wglcs/resetforgotpassword", obj);

    userSignUp = (name: string, email: string, password: string) => {
        let obj = {
            firstName: name,
            lastName: name,
            email: email,
            password: password,
            confirmPassword: password,
            facebookId: null,
            pictureUrl: null,
        };

        return this.instance.post("auth/authenticate", obj, {
            headers: {
                "callback-url": "http://localhost:3000/",
                "access-token": "pnqxdcABJPkKu0IvtjNvtWqD6iNUxqBaxivBrJwzUfNv4Nbq1S",
            },
        });
    };

    forgotPassword = (email: string): Promise<AxiosResponse<ApiResult<string>, any>> => {
        return this.instance.get<ApiResult<string>>(`wglcs/forgetpassword?userEmail=${email}`, {
            headers: {
                "callback-url": `${DetectEnvironment.config.REACT_APP_HOST_URL}/#/newPassword?t=[TOKEN]`,
            },
        });
    };

    //...................................Chat Transcript
    getallusersofempcompany = (empCompanyId): Promise<AxiosResponse<ApiResult<AgentsMDL[]>>> =>
        this.instance.get(`wglcs/getallusersofempcompany?empCompanyId=${empCompanyId}`);
    getwebsitesbyempCompany = (empCompanyId): Promise<AxiosResponse<ApiResult<EmployeCompanyWebMDL[]>>> =>
        this.instance.get(`wglcs/getwebsitesbyempCompany?empCompanyId=${empCompanyId}`);

    getuserinterectedchattranscripts = (fromDate, toDate, userId): Promise<Result<string>> =>
        this.get<string>(`wglcs/getuserinterectedchattranscripts?fromData=${fromDate}&toData=${toDate}&userId=${userId}`);

    GetChatInfo = (body): Promise<AxiosResponse<ApiResult<ChatTranscriptData[]>>> => this.instance.post(`wglcs/GetChatInfo`, body);

    GetChatTranscriptsWithQCAgent = (body): Promise<Result<ChatTranscriptData[]>> =>
        this.post<ChatTranscriptData[]>(`wglcs/GetChatTranscriptsWithQCAgent`, body);

    GetChatTranscripts = (body): Promise<Result<ChatTranscriptData[]>> => this.post<ChatTranscriptData[]>(`wglcs/GetChatTranscripts`, body);
    getchattranscriptsindustrywise = (body): Promise<Result<ChatTranscriptData[]>> => this.post<ChatTranscriptData[]>(`wglcs/getchattranscriptsindustrywise`, body);
    getchattranscriptswithqcagentindustrywise = (body): Promise<Result<ChatTranscriptData[]>> => this.post<ChatTranscriptData[]>(`wglcs/getchattranscriptswithqcagentindustrywise`, body);

    getenableusersbycompany = (empCompanyId): Promise<AxiosResponse<ApiResult<EnableAgentsMDL[]>>> =>
        this.instance.get(`wglcs/getenableusersbycompany?empCompanyId=${empCompanyId}`);

    //...................................resources Pool
    GetUsersByCompany = (empCompanyId): Promise<AxiosResponse<ApiResult<AllResourcesData[]>>> =>
        this.instance.get(`wglcs/getusersbycompany?empCompanyId=${empCompanyId}`);
    getusersbycompany_serviceonly = (empCompanyId): Promise<AxiosResponse<ApiResult<AllResourcesData[]>>> =>
        this.instance.get(`wglcs/getusersbycompany_serviceonly?empCompanyId=${empCompanyId}`);
    getusertraninginfobyuserid = (userId): Promise<AxiosResponse<ApiResult<UserTrainingInfo[]>>> =>
        this.instance.get(`wglcs/getusertraninginfobyuserid?userId=${userId}`);
    getallstatuses = (): Promise<AxiosResponse<ApiResult<WebsiteStatus[]>>> => this.instance.get(`wglcs/getallstatuses`);
    getwebsitesbyempcompany_serviceonly = (empCompanyId): Promise<AxiosResponse<ApiResult<EmployeCompanyWebMDL[]>>> =>
        this.instance.get(`wglcs/getwebsitesbyempcompany_serviceonly?empCompanyId=${empCompanyId}`);
    getroleinterfaces = (): Promise<AxiosResponse<ApiResult<RoleInterface[]>>> => this.instance.get(`wglcs/getroleinterfaces`);
    saveusertrainedon = (body): Promise<Result<string>> => this.post<string>(`wglcs/saveusertrainedon`, body);

    getemployeecompanyies = (): Promise<AxiosResponse<ApiResult<employeeCompanyMDL[]>>> => this.instance.get(`wglcs/getemployeecompanyies`);
    getempcompanylanguagesdetail = (): Promise<AxiosResponse<ApiResult<LanguageMDL[]>>> => this.instance.get(`wglcs/getempcompanylanguagesdetail`);
    getrolesbyempcompanyid = (empCompanyId): Promise<AxiosResponse<ApiResult<companyRoleMDL[]>>> =>
        this.instance.get(`wglcs/getrolesbyempcompanyid?empCompanyId=${empCompanyId}`);
    updateuserinfo_v2 = (body): Promise<Result<string>> => this.post<string>(`wglcs/updateuserinfo_v2`, body);
    insertuserinfobll_v2 = (body): Promise<Result<string>> => this.post<string>(`wglcs/insertuserinfobll_v2`, body);
    setuserstatus = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/setuserstatus`, body);
    // ..................................................testing Module....................................
    modulesresults = (): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get(`wglcs/gettestingmodulesresults`);
    getrunningchats = (UserId, apiCode): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`wglcs/testingmodule_getrunningchats?UserId=${UserId}&apiCode=A981B8AD639E`);
    testingmodulechats_insert = (body): Promise<Result<string>> => this.post(`wglcs/testingmodulechats_insert`, body);
    emailrelatedinfo_insertv2 = (body): Promise<Result<string>> => this.post(`wglcs/emailrelatedinfo_insertv2`, body);
    insertvisitorinfotestingmodule = (body): Promise<Result<string>> => this.post(`wglcs/insertvisitorinfotestingmodule`, body);

    getcity = (countryName): Promise<AxiosResponse<ApiResult<companyRoleMDL[]>>> =>
        this.instance.get("wglcs/regionalinformationcityinfobycountry?countryName=" + countryName);

    // ............................................................
    picsupload = (body): Promise<AxiosResponse<ApiResult<string>>> => {
        var imageInstance = axios.create({
            baseURL: "https://blue.thelivechatsoftware.com/ChatAppApi/api/",
            headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
            },
            timeout: 200000,
        });

        var res = imageInstance.post<ApiResult<string>>("wglcs/picsupload", body);
        return res;
    };

    shareImagesToUpload = async (body, empComapnyId): Promise<AxiosResponse<ApiResult<string>>> => {
        var imageInstance = axios.create({
            baseURL: "https://thelivechatsoftware.com/FileUploader/api/",
            headers: {
                "Content-Type": "multipart/form-data",
                // 'Access-Control-Allow-Origin': '*',
            },
            timeout: 200000,
        });
        let endpoint;
        if (empComapnyId.toString() === "01-050") {
            endpoint = "FileUploader/FileTransfer3_5_OP_Interchanges";
        } else if (empComapnyId.toString() === "01-001") {
            endpoint = "FileUploader/FileTransfer3_5_OP_DEP";
        } else {
            endpoint = "FileUploader/FileTransfer3_5_OP";
        }

        var res = await imageInstance.post<ApiResult<string>>(endpoint, body);
        return res;
    };
    //...................................reports
    depdashboard_websitestats_userwise = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`wglcs/depdashboard_websitestats_userwise`, body);
    depdashboard_websitestats_hourwise = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`wglcs/depdashboard_websitestats_hourwise`, body);
    depdashboard_websitestats_daywise = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`wglcs/depdashboard_websitestats_daywise`, body);
    depdashboardwebsitestats_comanaged = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`wglcs/depdashboardwebsitestats_comanaged`, body);

    GetWebsitesByEmpCompany = (empCompanyId): Promise<AxiosResponse<ApiResult<companyRoleMDL[]>>> =>
        this.instance.get(`wglcs/getwebsitesbyempCompany?empCompanyId=${empCompanyId}`);
    getempcompanylanguages = (): Promise<AxiosResponse<ApiResult<LanguageMDL[]>>> => this.instance.get(`wglcs/getempcompanylanguagesdetail`);
    getallserviceschedulebywebsitelanguagebll = (webId, languageId): Promise<AxiosResponse<ApiResult<LanguageMDL[]>>> =>
        this.instance.get(`wglcs/getallserviceschedulesbywebitenlanguagebll?websiteId=${webId}&languageId=${languageId}`);
    saveserviceschedule = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/saveserviceschedule_new_v1`, body);
    //...................................set Zip code
    updateVisitorZipCode = (obj) => this.instance.post("wglcs/updatevisitorzipcode", obj);

    //.................................Smtp
    SmtpInfo_SelectAll = (): Promise<AxiosResponse<ApiResult<SmtpInfo_SelectAllModel[]>>> => this.instance.get(`wglcs/smtpinfo_selectall`);
    getUsersByCompany = (empCompanyId): Promise<AxiosResponse<ApiResult<getUsersByCompanyModel[]>>> =>
        this.instance.get(`wglcs/getusersbycompany?empCompanyId=${empCompanyId}`);
    usersmtpaddress_selectbyuserId = (userId): Promise<AxiosResponse<ApiResult<UsersmtpaddressModel[]>>> =>
        this.instance.get(`wglcs/usersmtpaddress_selectbyuserid?userId=${userId}`);
    usersmtpaddress_insert = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/usersmtpaddress_insert`, body);
    usersmtpaddress_update = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/usersmtpaddress_update`, body);
    usersmtpaddress_delete = (userAddressId): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`/wglcs/usersmtpaddress_delete?userAddressId=${userAddressId}`);

    //...................................
    SaveTicket_Clarification = (data) => this.instance.post("wglcs/SaveTicket_Clarification", data);

    //................................... Survey Questions
    applookup_bycategory = (category): Promise<AxiosResponse<ApiResult<AppLookUpByCategoryModel[]>>> =>
        this.instance.get("wglcs/applookup_bycategory?category=" + category);
    getSurveyQuestionsForUser = (userId): Promise<AxiosResponse<ApiResult<SurveyQuestionsForUserModel[]>>> =>
        this.instance.get("wglcs/getsurveyquestionsforuser?userId=" + userId);
    saveSurveyResultwithPopUpTime = (obj) => this.instance.post("wglcs/savesurveyresultwithpopuptime", obj);

    //...................................company module
    getwebsitebycompanyId = (comId): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get(`/wglcs/getwebsitebycomid?companyId=${comId}`);
    getallCompaniesbyEmployeeCompanyid = (empComId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/getallcompaniesbyemployeecompanyid?empCompanyId=${empComId}`);
    GetEnableUsersByCompany = (empComId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/getenableusersbycompany?empCompanyId=${empComId}`);
    savecompanyandwebsiteswithoutsmtpsetting = (body): Promise<Result<string>> =>
        this.post<string>(`wglcs/savecompanyandwebsiteswithoutsmtpsetting`, body);
    GetEmpCompanyLanguages = (): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/getempcompanylanguagesdetail");
    getwronglinkexception = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post("/wglcs/getwronglinkexception", body);
    saveWrongLinkException = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post("/wglcs/savewronglinkexception", body);
    RegionalInformation_CountryInfo = (): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get("/wglcs/regionalinformation_countryinfo");
    GetEmployeeCompanyies = (): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/getemployeecompanyies");
    SmtpInfo = (): Promise<AxiosResponse<ApiResult<SmtpModel[]>>> =>
        cacheService.getOrCreate(CacheKey.SmtpInfo, "", () => this.instance.get("/wglcs/SmtpInfo_SelectAll"));
    DeviceInfo_SelectAll = (): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/DeviceInfo_SelectAll");
    WebsiteGreetings_SelectByWebsiteId = (websiteId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`/wglcs/WebsiteGreetings_SelectByWebsiteId?websiteId=${websiteId}`);
    SaveWebGreetings = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/SaveWebGreetings`, body);
    checkdomainexist = (domainName: string): Promise<Result<string>> => this.get<string>(`wglcs/checkdomainexist?domainName=${domainName}`);

    insertClientPoc = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/clientpoc_insert`, body);

    getClientPoc = (companyId, empComId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/getclientpoc_bycompanyid?companyId=${companyId}&empCompanyID=${empComId}`);

    Applookup_bycategory = (category): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get("wglcs/applookup_bycategory?category=" + category);

    doencrypt = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/doencrypt`, body);

    getClientPoc_Log = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get(`wglcs/getclientpoc_log?websiteId=${body}`);

    clientpoc_updatev1 = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/clientpoc_updatev1`, body);
    employeecompany_update = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post(`wglcs/employeecompany_update`, body);
    employeecompany_insert = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post(`wglcs/employeecompany_insert`, body);

    removeClientPoc = (body): Promise<Result<string>> => {
        var res = this.post<string>(`wglcs/removeclientpocbycompanyid`, body);
        return res;
    };

    //.....................................right click to send canned note .........................................
    sendemailforcannednote = (data) => this.instance.post("wglcs/sendemailforcannednote", data);
    autoticket_cannedmessage = (data) => this.instance.post("wglcs/autoticket_cannedmessage", data);

    gettodayexpiredcanned = (): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/gettodayexpiredcanned");

    getdepartmentinfoconfigurationbywebsiteid = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post("/wglcs/getdepartmentinfoconfigurationbywebsiteid", body);
    sendinvolveinvite_v2 = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/sendinvolveinvite_v2", body);
    senddepartmentinvolveemail = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/senddepartmentinvolveemail", body);

    //.....................................logs..........................................
    savewglog = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/savewglog", body);
    getuseridbynameandcompanyid = (userName, companyId): Promise<AxiosResponse<ApiResult<ChatTranscriptData[]>>> =>
        this.instance.get(`wglcs/getuseridbynameandcompanyid?username=${userName}&empCompanyId=${companyId}`);
    reportbug = async (body: FormData): Promise<AxiosResponse<ApiResult<string>>> => {
        var res = await this.instance.post<ApiResult<string>>("wglcs/reportbug", body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return res;
    };

    //...............Monitoring panel.....
    getchatsforuserwithresellerinfo = (userId: Number): Promise<Result<string>> =>
        this.get("/wglcs/getchatsforuserwithresellerinfo?userId=" + userId);
    getchatsfortraininguserwise = (body): Promise<Result<string>> => this.post("/wglcs/getchatsfortraininguserwise", body);
    getchatsformonitorpanel = (body): Promise<Result<string>> => this.post("/wglcs/getchatsformonitorpanel", body);
    getrunningmonitoredchatsforuser = (userId): Promise<Result<string>> => this.get("/wglcs/getrunningmonitoredchatsforuser?userId=" + userId);
    getchatsformonitorpaneluserwise = (body): Promise<Result<string>> => this.post("/wglcs/getchatsformonitorpaneluserwise", body);

    getunsentchats = (userId: Number): Promise<Result<string>> => this.get("/wglcs/getunsentchats?userId=" + userId);

    ChatInfoClaim_UpdateClaim = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/ChatInfoClaim_UpdateClaim", body);
    save_changedcannedmsg = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/save_changedcannedmsg", body);

    websitetextustwillioinfo_insertv1 = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post("/wglcs/websitetextustwillioinfo_insertv1", body);

    getwronglinkexceptionandsendemail = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post("/wglcs/getwronglinkexceptionandsendemail", body);

    getwronglinkexceptionlist = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/getwronglinkexceptionlist", body);

    send_verificationcode = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post("/wglcs/send_verificationcode", body);

    //........................monitoring panel popUp APi.......................//
    getticketpriorities = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/getticketpriorities", body);
    getticketdepartments = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/getticketdepartments", body);
    getsubtypesbytickettypeid = (ticketTypeId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`/wglcs/getsubtypesbytickettypeid?ticketTypeId=${ticketTypeId}`);
    //..................//

    getcannmessagesbyuserid_new = (body): Promise<AxiosResponse<ApiResult<PersonalCannedMessages[]>>> =>
        this.instance.post(`wglcs/getcannmessagesbyuserid_new`, body);

    chatnotes_insert = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`wglcs/chatnotes_insert`, body);

    liveoperatorsofemployeecompany = (empCompanyId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/liveoperatorsofemployeecompany?employeeCompanyId=${empCompanyId}`);

    getusersundertraining = (trainerId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/getusersundertraining?trainerId=${trainerId} `);

    deletetrainer = (trainerId): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`/wglcs/deletetrainer?trainerId=${trainerId} `);

    saveusersassignedtoatrainer = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`/wglcs/saveusersassignedtoatrainer`, body);

    save_stoppedchatinfo_v1 = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`/wglcs/save_stoppedchatinfo_v1`, body);

    monitoredchats_save_new = (body): Promise<AxiosResponse<ApiResult<string>>> => this.instance.post(`/wglcs/monitoredchats_savenew_v1`, body);

    getassignedwebsiteschatsnorealtime = (userId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`wglcs/getassignedwebsiteschatsnorealtime?userId=${userId}`);

    // .......Point System APIs
    rpt_BPSLeaderBoard = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/rpt_bpsLeaderBoard`, body);

    GetBPSImprovements = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/GetBPSImprovements`, body);
    GetBPSDataUserWise_V1 = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/GetBPSDataUserWise_V1`, body);
    // ...........

    updateuserbreaklogs = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updateuserbreaklogs`, body);

    saveuserbreaklogs = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/saveuserbreaklogs`, body);

    sendemailforgoodratingfrommonitoring_v1 = (body): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.post(`/wglcs/sendemailforgoodratingfrommonitoring_v1`, body);

    sendemailforgoodrating_v1 = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/sendemailforgoodrating_v1`, body);

    getemailconversationall = (chatId, chatStartTime): Promise<AxiosResponse<ApiResult<[]>>> =>
        this.instance.get(`/emailform/getemailconversationall?chatId=${parseInt(chatId)}&chatStartTime=${chatStartTime?.toString()}`);

    update_pendingpcm = (body): Promise<Result<string>> => this.post<string>(`wglcs/update_pendingpcm`, body);

    getLinkMetaData = (url: any) => this.instance.get("s2l/previewdata?paramURL=" + url);

    // .....................................Chat logs..........................................
    getchatsforlogs_new1_industrywise = (body) : Promise<Result<string>> => this.post<string>(`wglcs/getchatsforlogs_new1_industrywise`, body);
    getchatstats = (body): Promise<Result<string>> => this.post<string>(`wglcs/getchatstats`, body);
    getfeedbackscount = (body): Promise<Result<string>> => this.post<string>(`wglcs/getfeedbackscount`, body);

    getchatsforlogs_new1 = (body): Promise<Result<string>> => this.post<string>(`wglcs/getchatsforlogs_new1`, body);
    chatmessages_bychatid = (chatId): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get(`wglcs/chatmessages_bychatid?chatId=${chatId}`);
    logerrortype_selectall = (): Promise<AxiosResponse<ApiResult<string>>> => this.instance.get("/wglcs/logerrortype_selectall");
    visitorinfo_byvisitorid = (visitorId): Promise<Result<any>> => this.instance.get(`wglcs/visitorinfo_byvisitorid?visitorId=${visitorId}`);
    getvisitorurlsofwebsite = (visitorId, websiteId, chatId, ChatStartTime): Promise<Result<any>> =>
        this.instance.get(
            `/emailform/getvisitorurlsofwebsite?visitorId=${visitorId}&websiteId=${websiteId}&chatId=${chatId}&chatStartTime=${ChatStartTime.toString()}`
        );
    chatlogs_insert_v2 = (body): Promise<Result<string>> => this.post<string>(`wglcs/chatlogs_insert_v2`, body);
    getchatsofoperator = (params): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`wglcs/getchatsofoperator?userId=${params.userId}&fromDate=${params.fromdate}&toDate=${params.todate}`);

    getchatsmessagesofoperators = (params): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`wglcs/getchatsmessagesofoperators?userId=${params.userId}&fromDate=${params.fromdate}&toDate=${params.todate}`);

    // ...................................Roles and Permissions.......
    getinterfacesbyempcompanyid = (empCompanyId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/getinterfacesbyempcompanyid?empCompanyId=${empCompanyId}`);
    getallrolepermissionsbyroleid = (roleId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/getallrolepermissionsbyroleid?roleId=${roleId}`);
    updateroleandpermission = (body): Promise<Result<string>> => this.post<string>(`wglcs/updateroleandpermission`, body);
    insertroleandpermission = (body): Promise<Result<string>> => this.post<string>(`wglcs/insertroleandpermission`, body);

    // .......Website Services Status APIs
    getwebsiteserviceschedule = (): Promise<Result<string>> => this.get(`wglcs/getwebsiteserviceschedule`);

    // ....................................Company Allowed Interface.....................
    insertempcompanyinterfaces = (body): Promise<Result<string>> => this.post<string>(`wglcs/insertempcompanyinterfaces`, body);

    getLicenseDetails = (employeeCompanyId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/licensedetails_selectbyempcompanyid?empCompanyId=${employeeCompanyId}`);
    insertLicenseDetails = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/licensedetails_insert`, body);
    updateLicenseDetails = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/licensedetails_Update`, body);
    //.................................Survey Question API............................................
    getalllanguages = (): Promise<Result<any>> => this.get(`wglcs/getalllanguages`);
    getwebsitequestions = (websiteId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/getwebsitequestions?websiteId=${websiteId}`);
    getanswersbyquestionid = (questionId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/getanswersbyquestionid?questionId=${questionId}`);
    GetSurveyQuestionsForUser = (userId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/GetSurveyQuestionsForUser_V1?userId=${userId}`);
    savequestionanswers = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/savequestionanswers_v3`, body);

    // ........................................Offline Email Exception.....................................
    getAllOfflineWebsites = (): Promise<Result<any>> => this.get(`wglcs/GetAllOfflineWebsites`);
    SaveOfflineWebsites = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/saveofflinewebsites`, body);
    // .......................................Offline Email...............................................
    OfflineEmail_SelectByWebsiteId = (websiteId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/OfflineEmail_SelectByWebsiteId?websiteId=${websiteId}`);
    SaveOfflineEmail = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/OfflineEmail_Save_V1`, body);

    //    .....................................................WG REPORTS.......................................
    departmentwisechatreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/departmentwisechatreport`, body);

    GetAllReportingTimeZones = (): Promise<Result<any>> => this.get(`wglcs/GetAllReportingTimeZones`);
    AverageResponseTimeandEngagementReport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/AverageResponseTimeandEngagementReport`, body);
    PageWiseChatReport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/PageWiseChatReport`, body);
    TrafficChatConversionRatiosReport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/TrafficChatConversionRatiosReport`, body);
    MonthlyAccountSummaryReport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/MonthlyAccountSummaryReport`, body);
    VisitorInfoWithTranscriptReport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/VisitorInfoWithTranscriptReport`, body);
    chatnumbersperdayofweek = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/chatnumbersperdayofweek`, body);
    monthwisestatisticoflicense = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/monthwisestatisticoflicense`, body);
    meaningfulchatforweekdayweekend = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/meaningfulchatforweekdayweekend`, body);
    monthlytrafficreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/monthlytrafficreport`, body);
    monthwisechatcountgraph = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/monthwisechatcountgraph`, body);
    hourwisechatsreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/hourwisechatsreport`, body);
    hourwisechatsofwebsitereport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/hourwisechatsofwebsitereport`, body);
    ratingwisereport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/ratingwisereport`, body);
    countrywisereport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/countrywisereport`, body);
    multiplemonthlyaccountsummaryreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/multiplemonthlyaccountsummaryreport`, body);
    hourwisechatsofacompanyreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/hourwisechatsofacompanyreport`, body);
    getlasoftwareonlyclients = (): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get(`/wglcs/getlasoftwareonlyclients`);
    getwebsitesfordepvsdealermanaged = (): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get(`/wglcs/getwebsitesfordepvsdealermanaged`);
    lavsdealermanaged = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/lavsdealermanaged`, body);
    depvsdealermanaged = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/depvsdealermanaged`, body);
    getwebsitedistributionreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/getwebsitedistributionreport`, body);
    getchatdetailswrtvisitors = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/getchatdetailswrtvisitors`, body);
    getallchattranscripts = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/getallchattranscripts`, body);
    getchatdetailbychatidforreport = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/getchatdetailbychatidforreport`, body);
    getallchattranscriptsexpanded = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/getallchattranscriptsexpanded`, body);
    monthlyaccountsummarymultiplemonth = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/monthlyaccountsummarymultiplemonth`, body);
    getwebsitebymultiplecompids = (companyIds): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/getwebsitebymultiplecompids?companyIds=${companyIds}`);
    getallchattranscriptswithlinks = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/getallchattranscriptswithlinks`, body);
    noofchatsbyagents = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/noofchatsbyagents`, body);
    locationwisereport = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/locationwisereport`, body);
    billablechattranscriptofwebsiteexpanded = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/billablechattranscriptofwebsiteexpanded`, body);
    hourlyvisitorscount = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/hourlyvisitorscount`, body);
    ppcorganicchattranscriptofwebsite = (body): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.post(`wglcs/ppcorganicchattranscriptofwebsite`, body);
    getagentsforhourlychats = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/getagentsforhourlychats`, body);
    hourlychatcountagentwise = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post(`wglcs/hourlychatcountagentwise`, body);
    dailygrowthofleads = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/dailygrowthofleads`, body);
    chatcountbycompany = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/chatcountbycompany`, body);

    getbotchatslocationwisestats = (params): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`botfront/getbotchatslocationwisestats?fromDate=${params.fromDate}&toDate=${params.toDate}&WebsiteId=${params.websiteId}`);
    getbotchatslocationwisev1 = (params): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`botfront/getbotchatslocationwisev1?fromDate=${params.fromDate}&toDate=${params.toDate}&WebsiteId=${params.websiteId}`);

    getjsondata = (params): Promise<AxiosResponse<ApiResult<any>>> =>
        this.instance.get(`botai/getjsondata?websiteId=${params.websiteId}&monthDate=${params.monthDate}`);
    // .........................................
    // .......................................... Custom Schedule ..........................................
    addcustomservicescheduler = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/addcustomservicescheduler`, body);
    updatecustomservicescheduler = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/updatecustomservicescheduler`, body);
    selectallcustomservicescheduler = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/selectallcustomservicescheduler`, body);
    removecustomservicescheduler = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/removecustomservicescheduler`, body);
    removecustomservicescheduleragainstwebsite = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/removecustomservicescheduleragainstwebsite`, body);
    // .......................................................................................
    sendtestingmoduleemail = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/sendtestingmoduleemail`, body);
    // ....................................
    getlastmonthperformance_userandwebsite = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/getlastmonthperformance_userandwebsite`, body);
    getrealtimechatstatsbyuser = (userId): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.get(`wglcs/getrealtimechatstatsbyuser?userId=${userId}`);
    getIpAddress = async (): Promise<string> => {
        const fallbackIP = "0.0.0.0";
        try {
            const res = await axios.get("https://api.ipify.org/?format=json");
            if (res.status === 200 && res.data?.ip) {
                return res.data.ip;
            } else {
                console.error("IP address not found in the response.");
                return fallbackIP;
            }
        } catch (error: any) {
            console.error("Error fetching IP address:", error.message || error);
            return fallbackIP;
        }
    };

    checkForServerDownAPI = async (): Promise<string> => {
        const fallback = "API Error";
        try {
            const res = await axios.get("https://cdn1.thelivechatsoftware.com/cwgapi/api/values/Get?id=1");
            
            if (res.status === 200) {
                return res.data.Result;
            } else {
                return fallback;
            }
        } catch (error: any) {
            console.error("Error fetching:", error.message || error);
            return fallback;
        }
    };

    // .........................................Involve Configurations.............................
    getinvolvecompanies = (): Promise<Result<string>> => this.get(`wglcs/getinvolvecompanies`);
    GetWebsitesByEmpCompanyInvolve = (empCompanyId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/GetWebsitesByEmpCompanyInvolve?empCompanyId=${empCompanyId}`);
    GetUserConfigurationsByEmpCompany = (EmpCompanyId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/GetUserConfigurationsByEmpCompany?EmpCompanyId=${EmpCompanyId}`);
    GetDepartmentInfoConfigurationbyWebsiteID = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/getdepartmentinfoconfigurationbywebsiteid`, body);
    SaveUserConfigurations = (body): Promise<AxiosResponse<ApiResult<any[]>>> => this.instance.post(`wglcs/saveuserconfigurations`, body);
    addDepartmentConfiguration = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/adddepartmentconfigurationbywebsiteid`, body);
    DeleteDepartmentConfigurationByWebsiteID = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        this.instance.post(`wglcs/deletedepartmentconfigurationbywebsiteid`, body);
    getVideoSDKJWT = (body): Promise<AxiosResponse<ApiResult<any[]>>> =>
        axios.post(`https://dev1.thelivechatsoftware.com/ChatAppApi/api/dynamic/generatetoken`, body);

    // ............................................Master QC.................................................
    getallrunningchatsonqc_v1 = (body): Promise<AxiosResponse<ApiResult<any>>> => this.instance.post(`wglcs/getallrunningchatsonqc_v1`, body)

// .................................................View All Resources...................................
    getwebsitesCoverage = (empCompanyId): Promise<AxiosResponse<ApiResult<[] | any>>> =>
        this.instance.get(`/wglcs/getwebsitesCoverage?empCompanyId=${empCompanyId}`);


// .............



    // Book Appointment APIs
    getappointmentcrminfo = (): Promise<AxiosResponse<ApiResult<any>>> => this.instance.get("/wglcs/getappointmentcrminfo")
    getappointmentintegrationbywebsite = (websiteId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`/wglcs/getappointmentintegrationbywebsite?websiteId=${websiteId}`);
    getwebsiteappointmenthours = (websiteId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.get(`/wglcs/getwebsiteappointmenthours?websiteId=${websiteId}`);
    updatewebsiteappointmentdetails = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`/wglcs/updatewebsiteappointmentdetails`, body);
    updateappointmentschedule = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`/wglcs/updateappointmentschedule`, body);
    insertwebsiteappointmentdetails = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`/wglcs/insertwebsiteappointmentdetails`, body);
    insertappointmentschedule = (body): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`/wglcs/insertappointmentschedule`, body);
    deleteappointmentintegrationbywebsiteid = (websiteId): Promise<AxiosResponse<ApiResult<string>>> =>
        this.instance.post(`/wglcs/deleteappointmentintegrationbywebsiteid?websiteId=${websiteId}`);




    //webform apis
    getFieldTypes = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getfieldtypes`);
    getDropdownsForAttachment = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getdropdownsforattachment`);
    getDropdownsValuesForAttachment = (fieldid): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getdropdownvaluesforattachment?fieldId=${fieldid}`);
    getSystemFields = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getsystemfields`);
    getHelperTags = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/gethelpertags`);
    insertTag = (value): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/inserthelpertag?tag=${value}`);
    insertBaseField = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/insertbasefield`, body);
    updateBaseField = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updatebasefield`, body);
    searchTags = (search): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/searchhelpertags?keyword=${search}`);
    searchBaseFields = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/searchbasefields`, body);
    getBaseFieldDetails = (fieldId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getbasefielddetails?fieldId=${fieldId}`);
    getCrmTypes = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getcrmtypes`);
    getWebsiteDepartmentForEmailForm = (websiteid): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getwebsitedepartmentforemailform?websiteId=${websiteid}`);
    getattachmentdropdownforform = (formId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getattachmentdropdownforform?formId=${formId}`);
    getWebsiteDepartmentDetails = (websiteid): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getwebsitedepartmentdetails?departmentId=${websiteid}`);
    getDropdownValuesForFormAttachment = (formFieldId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getdropdownvaluesforformattachment?formFieldId=${formFieldId}`);
    getFormFieldDetails = (formFieldId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getformfielddetails?formFieldId=${formFieldId}`);
    getFormDetails = (formId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getcrmformdetails?formId=${formId}`);
    getCrmFormList = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getcrmformlist`);
    getCrmFormForPreview = (formid): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getcrmformforpreview?formId=${formid}`);
    getClientFields = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getclientfields`);
    updateWebsiteCrmVariables = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updatewebsitecrmvariables`, body);
    updateFormField = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updateformfield`, body);
    updateFormFieldsSort = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updateformfieldssort`, body);
    insertWebsiteDepartment = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/insertwebsitedepartment`, body);
    updateWebsiteDepartment = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updatewebsitedepartment`, body);
    insertCrmForm = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/insertcrmform`, body);
    insertFormField = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/insertformfield`, body);
    updateCrmForm = (body): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/updatecrmform`, body);
    getWebsiteCrmVariablesAgainstForm = (websiteId, formId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getwebsitecrmvariablesagainstform?websiteId=${websiteId}&formId=${formId}`);
    deleteFormField = (formFieldId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.post(`/wglcs/deleteformfield?formFieldId=${formFieldId}`);
    getAllRegexes = (): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getallregex`);
    //form render APIs
    getCrmFormRender = (object, formId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/wglcs/getcrmformforrender?formId=${formId}&visitorId=${object?.VisitorId}&chatId=${object?.ChatId}&websiteId=${object?.WebsiteId}&userId=${object?.UserId}&chatStartTime=${object?.ChatStartTime}`);
    getVisitorInformation = (visitorId, chatStartTime): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/emailform/getvisitorinformation?visitorId=${visitorId}&chatStartTime=${chatStartTime}`);
    getEmailConversationWithoutTrainer = (chatId, chatStartTime): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/emailform/getemailconversationwithouttrainer?chatId=${chatId}&chatStartTime=${chatStartTime}`);
    getAllChatTypes_V1 = (websiteId): Promise<AxiosResponse<ApiResult<[] | any>>> => this.instance.get(`/emailform/getallchattypes_v1?websiteId=${websiteId}`);
    postcrmFormData = async (body: FormData): Promise<AxiosResponse<ApiResult<string>>> => {
        var res = await this.instance.post<ApiResult<string>>("wglcs/postcrmformdata", body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return res;
    };
    //webform apis ended





    get = async <T>(path: string): Promise<Result<T>> => {
        try {
            var result = await this.instance.get<ApiResult<T>>(path);

            return {
                success: result.status >= 200 && result.status <= 299,
                data: result.data.data,
                errors: [],
                message: result.data.msg,
            } as Result<T>;
        } catch (ex) {
            var exception = ex as AxiosError;
            var response: ApiResult<T> | null = (exception?.response?.data as ApiResult<T>) ?? null;

            return {
                success: false,
                data: null,
                message: exception.message,
                errors: response?.error,
            } as unknown as Result<T>;
        }
    };

    post = async <T>(path: string, data: any): Promise<Result<T>> => {
        try {
            var result = await this.instance.post<ApiResult<T>>(path, data);

            return {
                success: result.status >= 200 && result.status <= 299 && result.data.status,
                data: result.data.data,
                message: result.data.msg,
                errors: [],
            } as Result<T>;
        } catch (ex) {
            var exception = ex as AxiosError;
            var response: ApiResult<T> | null = (exception?.response?.data as ApiResult<T>) ?? null;

            return {
                success: false,
                data: null,
                message: exception.message,
                errors: response?.error,
            } as unknown as Result<T>;
        }
    };

    translateText = async (text: string, source?: string, mode?: string) => {
        let target = "";

        var userData = userService.GetUserData();
        if (userData) {
            const userLang = userData?.userLoginData.languageId;
            const langObj = await utils.getLanguageNameById(userLang);
            const lang = langObj?.languageName.split(" ")[1];
            target = lang!.replace(/[()]/g, "");
        }

        const apiKey = this.translationApiKey;
        const apiUrl = "https://translation.googleapis.com/language/translate/v2";
        if (text && target && source && target != source) {
            try {
                const response = await axios.post(
                    apiUrl,
                    {
                        q: text,
                        target: mode == "operator" ? source : target,
                        format: "text",
                        // source: 'zh-CN', // Source language (English)
                        source: mode == "operator" ? target : source,
                    },
                    {
                        params: {
                            key: apiKey,
                        },
                    }
                );

                const translatedText = response.data.data.translations[0].translatedText;
                return translatedText;
                // console.log(`Translated Text: ${translatedText}`);
            } catch (error) {
                console.error("Translation error:", error);
            }
        }
        return text;
    };

    detectLanguage = async (text: string) => {
        const apiKey = this.translationApiKey;

        const apiUrl = "https://translation.googleapis.com/language/translate/v2/detect";

        try {
            const response = await axios.post(
                apiUrl,
                {
                    q: text,
                },
                {
                    params: {
                        key: apiKey,
                    },
                }
            );

            const detectedLanguage = response.data.data.detections[0][0].language;
            return detectedLanguage;
            // console.log(`Detected Language: ${detectedLanguage}`);
        } catch (error) {
            console.error("Language detection error:", error);
        }
    };

    deleteApiFromCache = (apiEndpoint: string) => {
        const url = new URL(this.baseApiUrl + "/wglcs" + apiEndpoint);
        if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: "refresh-api",
                api: url.pathname,
            });
        }
    };

    deleteApiCache = () => {
        if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: "delete-api-cache",
            });
        }
    };
}

var wglcsApiService = new WglcsApiService();
export { wglcsApiService };
